import { z } from "zod";

const apiRepresentation2dSchema = z.object({
    representationType: z.string(),
    materialId: z.number().nullable()
  });

export default apiRepresentation2dSchema;